import React from 'react';
import Fullscreen from 'wix-rich-content-fullscreen';
import { isFunction } from 'lodash';

const ViewerModal = ({
  index,
  isOpen,
  images,
  onClose,
  isMobile,
  backgroundColor,
  foregroundColor,
  container
}) => {
  return /* @__PURE__ */ React.createElement(
    Fullscreen,
    {
      isOpen,
      images,
      onClose,
      isMobile,
      index,
      backgroundColor,
      foregroundColor,
      target: isFunction(container) ? container() : container
    }
  );
};

export { ViewerModal as default };
//# sourceMappingURL=FullscreenModal.js.map
